import { Select, MenuItem, FormControl, InputLabel, Grid } from '@mui/material';
import React from 'react';
import { getGstFinancialYears } from 'utils/FinancialYears';
import SearchContainer from 'components/SearchContainer';

interface Props {
    selectedYear: string;
    setSelectedYear: (year: string) => void;
    searchValue?: string;
    onSearchChange?: (v: string) => void;
}

const FinancialYearAndMonthSelector = ({ selectedYear, setSelectedYear, searchValue, onSearchChange }: Props) => {


    // Calculate the current financial year
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const startFinancialYear = currentMonth >= 3 ? currentYear : currentYear - 1; // Financial year starts from April

    // Generate the list of financial years from 2017-2018 to the current financial year
    const financialYears: string[] = [];
    for (let year = startFinancialYear; year >= 2017; year--) {
        financialYears.push(`${year}-${(year + 1).toString().slice(2)}`);
    }


    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };


    return (
        <Grid container display="flex" alignItems="center" flexWrap="wrap" gap={2}>
            <Grid item>
                <FormControl>
                    <InputLabel>FY</InputLabel>
                    <Select
                        label="FY"
                        value={selectedYear}
                        onChange={handleYearChange}
                        sx={{ width: 120, height: 40 }}
                    >
                        {getGstFinancialYears().map((year) => (
                            <MenuItem key={year} value={year}>
                                {year}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            {onSearchChange && (
                <Grid item>
                    <SearchContainer
                        value={searchValue}
                        debounced
                        onChange={onSearchChange}
                        placeHolder="Search by Client Name | GSTIN | ARN"
                        minWidth="450px"
                        maxWidth="750px"
                    />
                </Grid>
            )}
        </Grid>
    );
}


export default FinancialYearAndMonthSelector;


